var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dr-row',{staticClass:"down-item",attrs:{"justifyContent":"space-between","alignItems":"center"},on:{"click":function($event){return _vm.pdfItemClick(_vm.pdfObj)}}},[_c('van-icon',{attrs:{"name":"static/imgs/pdf-icon.png","size":"33"}}),_vm._v(" "),_c('div',{staticClass:"down-title"},[_vm._v(_vm._s(_vm.pdfObj.name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1d04d5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdf/index.vue
// module id = null
// module chunks = 